import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { FuseMaterialColorPickerModule } from '@fuse/components/material-color-picker/material-color-picker.module';
import { FuseSharedModule } from '@fuse/shared.module';

import { FcSendEmailMessageDialogModule } from '@core/components/fc-send-email-message-dialog/fc-send-email-message-dialog.module';
import { DialogReallocateMaintenanceComponent } from './dialog-reallocate-maintenance.component';
import { TabReallocateMaintenanceModule } from './tabs/general/tab-general.module';

@NgModule({
    entryComponents: [
        DialogReallocateMaintenanceComponent
    ],
    declarations: [
        DialogReallocateMaintenanceComponent
    ],
    imports: [
        TranslateModule,

        FuseSharedModule,
        FuseMaterialColorPickerModule,
        FcSendEmailMessageDialogModule,

        MatIconModule,
        MatToolbarModule,
        MatInputModule,
        MatDialogModule,
        MatButtonModule,
        MatMenuModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatTooltipModule,
        MatCheckboxModule,

        TabReallocateMaintenanceModule
    ],
    exports: [
        DialogReallocateMaintenanceComponent
    ]
})
export class DialogReallocateMaintenanceModule { }
